import { render, staticRenderFns } from "./BlogSection.vue?vue&type=template&id=5608b399&"
import script from "./BlogSection.vue?vue&type=script&lang=js&"
export * from "./BlogSection.vue?vue&type=script&lang=js&"
import style0 from "./BlogSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports